import { BaseShareActionArgs, buildShareButtonComponent } from './base'
import { InstagramIcon } from '../../assets/icons'
import { copyToClipboard, getShareURL } from '../../helpers/sharing_helper'

export const instagramAction = ({ shareUrl, utmParams }: BaseShareActionArgs) => {
  copyToClipboard(getShareURL(shareUrl, utmParams))
}

export const InstagramButton = buildShareButtonComponent({
  action: instagramAction,
  ariaLabel: 'Instagram',
  className: 'share-button--instagram',
  icon: InstagramIcon,
})

export type InstagramButtonProps = Parameters<typeof InstagramButton>['0']
